import FoundryLink from "../../components/FoundryLink";
import Head from "next/head";
import Link from "next/link";
import { PageFadeWrapper } from "../../components/PageWrapper";
import ResponsiveImage from "../../components/ResponsiveImage";
import imgAceVisitor2025 from "../../public/img/about/fairs/ace-visitor-2025 1.png";
import imgAnimenyc2025 from "../../public/img/about/fairs/animenyc-2025.png";
import imgAppleActivation1Adjusted from "../../public/img/about/work/apple-activation-1-adjusted.jpg";
import imgAppleActivationWorking from "../../public/img/about/work/apple-activation-working.png";
import imgCommunity1 from "../../public/img/about/community-1.png";
import imgCommunity2 from "../../public/img/about/community-2.png";
import imgCommunity3 from "../../public/img/about/community-3.png";
import imgConcourseBinding12 from "../../public/img/about/concourse-binding-1-2.jpg";
import imgConcourseBindingHorizLg from "../../public/img/about/concourse-binding-1-2-horiz-lg.png";
import imgConcourseSituVertLg from "../../public/img/about/products/concourse-situ-vert-lg.png";
import imgDocusignRenaissanceAdjusted from "../../public/img/about/work/docusign-renaissance-adjusted.png";
import imgEmailBlack from "../../public/img/about/email-black.png";
import imgExhibition from "../../public/img/about/exhibition.png";
import imgFriendship3 from "../../public/img/about/fairs/friendship-3.jpg";
import imgHsfLandscape from "../../public/img/about/fairs/hsf-landscape.jpg";
import imgLaabf from "../../public/img/about/fairs/laabf.png";
import imgNike170717 from "../../public/img/about/work/nike/170717 1.png";
import imgNucleus from "../../public/img/about/fairs/nucleus.png";
import imgPathways from "../../public/img/about/products/pathways.jpg";
import imgPixelTypeOutput from "../../public/img/about/work/pixel-type-output.png";
import imgPoetryCoversCompiledTrimmed from "../../public/img/about/work/poetry-covers-compiled-trimmed.png";
import imgProductionBroadwayMural from "../../public/img/about/work/production-broadway-mural.jpg";
import imgProductionWtc from "../../public/img/about/production-wtc.jpg";
import imgProductionYana from "../../public/img/about/production-YANA.png";
import imgSabf2025 from "../../public/img/about/fairs/sabf-2025 1.png";
import imgSpacetypeKittyTigersPromo from "../../public/img/about/products/spacetype-kitty-tigers-promo.jpg";
import imgSpacetypePrintsPromo from "../../public/img/about/products/spacetype-prints-promo.jpg";
import imgSpeakingLg from "../../public/img/about/speaking-lg.png";
import imgUe17 from "../../public/img/about/fairs/ue17.png";
import imgWorkingHard from "../../public/img/about/working-hard.png";
import imgWorkingKnowledgeLandscape from "../../public/img/about/working-knowledge-landscape 1.png";

function About() {
  const PUBLICATION_FAIRS = [
    {
      host: "Land to Sea's Small World Market",
      link: "https://www.abronsartscenter.org/programs/artmarket-landtosea",
      dates: "Oct 2026"
    },
    {
      host: "Printed Matter - New York Art Book Fair",
      link: "https://printedmatterartbookfairs.org/",
      dates: "Sep 2026",
    },
    {
      host: "Riso Art & Zine (RAZ) Fest @ Gallery Nucleus",
      link: "https://gallerynucleus.com/events/1136",
      dates: "Sep 2026",
    },
    {
      host: "Anime NYC",
      link: "https://animenyc.com/",
      dates: "Aug 2026",
    },
    {
      host: "Seattle Art Book Fair",
      link: "https://www.seattleartbookfair.org/",
      dates: "May 2026",
    },
    {
      host: "Jersey Art Book Fair",
      link: "https://www.jerseyartbookfair.org/",
      dates: "Apr 2026",
    },
    {
      host: "Other Islands Art Book Fair",
      link: "https://otherislands.designfuture.space/",
      dates: "Apr 2026",
    },
    {
      host: "Welcome to Chinatown Holiday Popup",
      link: "https://welcometochinatown.com/events/holidaymarket",
      dates: "Dec 2025",
    },
    {
      host: "Unlimited Edition (Seoul Art Book Fair)",
      link: "https://unlimited-edition.org/",
      dates: "Nov 2025",
    },
    {
      host: "Riso Art & Zine (RAZ) Fest @ Gallery Nucleus",
      link: "https://gallerynucleus.com/events/1090",
      dates: "Sep 2025",
    },
    {
      host: "Friendship Market",
      link: "https://www.instagram.com/friendshipmarket",
      dates: "Sep 2025",
    },
    {
      host: "Anime NYC",
      link: "https://animenyc.com/",
      dates: "Aug 2025",
    },
    {
      host: "Smol Art Mart",
      link: "https://smolartmart.carrd.co/",
      dates: "Aug 2025",
    },
    {
      host: "ACE Popup Market @ Asian Creative Festival",
      link: "https://www.acepopup.com/",
      dates: "May 2025",
    },
    {
      host: "Printed Matter - LA Art Book Fair",
      link: "https://printedmatterartbookfairs.org/",
      dates: "May 2025",
    },
    {
      host: "Seattle Art Book Fair",
      link: "http://seattleartbookfair.org/",
      dates: "May 2025",
    },
    {
      host: "RISO Expo Philly",
      link: "https://www.phillysoapbox.org/riso-expo-philly",
      dates: "May 2025",
    },
    {
      host: "Welcome to Chinatown x Poster House - Print (Night) Market",
      link: "https://posterhouse.org/event/first-friday-night-market-curated-by-welcome-to-chinatown/",
      dates: "May 2025",
    },
    {
      host: "Multiple Formats Art Book Fair",
      link: "https://multipleformats.cargo.site/",
      dates: "Mar 2025",
    },
    {
      host: "Jersey Art Book Fair",
      link: "https://www.jerseyartbookfair.org/",
      dates: "Feb 2025",
    },
    {
      host: "Pyperbleu - Heart to Heart Market",
      link: "https://www.instagram.com/p/DGDy1wsxcoz",
      dates: "Feb 2025",
    },
    {
      host: "Welcome to Chinatown - Lunar New Years Fair",
      link: "https://welcometochinatown.com/lunarnewyear",
      dates: "Feb 2025",
    },
    {
      host: "Pioneer Works - Press Play",
      link: "https://pioneerworks.org/programs/press-play-2024",
      dates: "Dec 2024",
    },
    {
      host: "Sunnyday Art Market",
      link: "https://partiful.com/e/eJznGzQckcTveRB2fIHR",
      dates: "Sep 2024",
    },
    {
      host: "Multiple Formats Art Book Fair",
      link: "https://multipleformats.cargo.site/",
      dates: "Mar 2024",
    },
    {
      host: "Pioneer Works - Press Play",
      link: "https://pioneerworks.org/programs/press-play-2023",
      dates: "Dec 2023",
    },
    {
      host: "Lucky Risograph - Lucky & Friends Holiday Market",
      link: "https://www.instagram.com/p/CzrzA9eOHqt/",
      dates: "Dec 2023",
    },
    {
      host: "Pioneer Works x SFPC - S4AD Art Fair",
      link: "https://pioneerworks.org/programs/software-for-artists-day-8",
      dates: "Nov 2023",
    },
    {
      host: "Hester Street Fair",
      link: "https://www.hesterstreetfair.com/events/zine-fair-with-commercial-type-and-dahsar",
      dates: "Sep 2023",
    },
    {
      host: "Flamecon",
      link: "https://www.flamecon.org/",
      dates: "Aug 2023",
    },
    {
      host: "Typographics Book Fair",
      link: "https://2023.typographics.com/book_fair/",
      dates: "Jun 2023",
    },
    {
      host: "Principles Vendor Market",
      link: "https://www.instagram.com/principlesbk",
      dates: "Jun 2023",
    },
    {
      host: "Other Islands Book Fair",
      link: "https://designfuture.space/events/otherislands/",
      dates: "Apr 2023",
    },
  ];

  const RETAILERS = [
    {
      host: "Antenne Books (Distribution)",
      link: "https://antennebooks.com/",
      location: "Europe",
    },
    {
      host: "The Magazine Club",
      link: "https://www.instagram.com/the_magazine_club",
      location: "Seoul, South Korea"
    },
    {
      host: "Printed Matter",
      link: "https://www.printedmatter.org/",
      location: "New York, NY",
    },
    {
      host: "The Bronx Museum",
      link: "https://bronxmuseum.org/",
      location: "Bronx, NY",
    },
    {
      host: "New Museum Store",
      link: "https://www.newmuseumstore.org/",
      location: "New York, NY",
    },
    {
      host: "Secret Riso Club",
      link: "https://secretrisoclub.com/",
      location: "Brooklyn, NY",
    },
    { host: "Kvartira Books", location: "Brooklyn, NY" },
    {
      host: "Gallery Nucleus",
      link: "https://gallerynucleus.com/",
      location: "Alhambra, CA",
    },
    {
      host: "Heath Newsstand",
      link: "https://heathnewsstand.com/",
      location: "San Francisco, CA",
    },
    {
      host: "Now Place",
      link: "https://www.nowplacesf.com/",
      location: "San Francisco, CA",
    },
    {
      host: "Cool Cat Collective",
      link: "https://coolcatcollective.co/",
      location: "Long Beach, CA",
    },
    {
      host: "Pygmy Hippo Shoppe",
      link: "https://pygmyhipposhoppe.com/",
      location: "Los Angeles, CA",
    },
    {
      host: "Skylight Books",
      link: "https://www.skylightbooks.com/",
      location: "Los Angeles, CA",
    },
    {
      host: "Secret Room",
      link: "https://www.secretroompress.com/",
      location: "Portland, OR",
    },
    {
      host: "Paper Pushers",
      link: "https://seattlerestored.org/locations/paper-pushers-print-shop/",
      location: "Seattle, WA",
    },
    {
      host: "Common Objects Bookstore",
      link: "https://www.camseattle.org/bookstore",
      location: "Seattle, WA",
    },
    {
      host: "Katherine Small Gallery",
      link: "https://ksmallgallery.com/",
      location: "Somerville, MA",
    },
    {
      host: "Pigeon Post",
      link: "https://pigeonpost.shop/",
      location: "Scranton, PA",
    },
  ];

  const TEACHING_AND_WORKSHOPS = [
    {
      host: "Jersey Art Book Fair",
      link: "https://www.jerseyartbookfair.org/",
      title: "Pixel Type Workshop",
      dates: "Feb 2025",
    },
    {
      host: "University of Connecticut",
      link: "https://uconn.edu/",
      title: "Intro to p5.js",
      dates: "Jan-Feb 2025",
    },
    {
      host: "Bronx Museum of the Arts",
      link: "https://bronxmuseum.org/learn/",
      title: "Type Design Workshops",
      dates: "Nov 2024",
    },
    {
      host: "Type Electives",
      link: "https://www.typeelectives.com/courses/techniculture-sp-24",
      title:
        "Techniculture: A Critical Lens on Modular Type and Generative Design",
      dates: "Feb-Mar 2024",
    },
    {
      host: "Parsons School of Design",
      link: "https://courses.newschool.edu/courses/PSAM3060/",
      title: "Currents: CD Workshop (Machine Learning)",
      dates: "Oct-Nov 2023",
    },
    {
      host: "Processing Foundation",
      link: "https://medium.com/@ProcessingOrg/announcing-google-summer-of-code-2023-mentors-4d126e35a23d",
      title: "GSoC Typography Mentorship",
      dates: "Jun-Aug 2023",
    },
    {
      host: "Type Electives",
      link: "https://www.typeelectives.com/events/pixel-type-workshop-tickets-559039039817",
      title: "Pixel Type Workshop",
      dates: "Mar 2023",
    },
    {
      host: "Type Electives",
      link: "https://www.typeelectives.com/courses/intro-to-generative-typography-with-p5js-sp-23",
      title: "Intro to Generative Typography with p5.js",
      dates: "Jan-Apr 2023",
    },
    {
      host: "Letràstrica",
      link: "https://www.letrastica.com/en/festival-4",
      title: "Generative Typography",
      dates: "Oct 2022",
    },
    {
      host: "Letterform Archive",
      link: "https://letterformarchive.org/type-west-online/",
      title: "Type West: Type Design",
      dates: "Jun-Aug 2022",
    },
    {
      host: "Letterform Archive",
      link: "https://letterformarchive.org/events/view/in-person-core-prototyping-letterforms/",
      title: "In-Person Core: Prototyping Letterforms",
      dates: "Jun 2022",
    },
    {
      host: "Letterform Archive",
      link: "https://letterformarchive.org/shop/the-basics-of-designing-flourishes/",
      title: "Designing Flourishes",
      dates: "Jun 2022",
    },
    {
      host: "Typographics",
      link: "http://coopertype.dreamhosters.com/events/code_x_kinetic_type_su2022",
      title: "Code x Kinetic Type",
      dates: "Jun 2022",
    },
    {
      host: "Type@Cooper",
      link: "http://coopertype.dreamhosters.com/events/generative_type_sp2021",
      title: "Generative Typography",
      dates: "Feb-Apr 2022",
    },
    {
      host: "Parsons School of Design",
      link: "https://courses.newschool.edu/courses/PSAM3010",
      title: "CD Studio: Typeface Design",
      dates: "Jan-May 2022",
    },
    {
      host: "Typographics",
      link: "https://github.com/spacetypeco/kinetic-type-SU21",
      title: "Code x Kinetic Type",
      dates: "Jun 2021",
    },
    {
      host: "Typographics",
      link: "http://coopertype.dreamhosters.com/events/code_x_glitch_type",
      title: "Code x Glitch Type",
      dates: "Jun 2021",
    },
    {
      host: "Typographics",
      link: "http://coopertype.dreamhosters.com/events/code_x_variable_fonts",
      title: "Code x Variable Fonts",
      dates: "Jun 2021",
    },
    {
      host: "Society of Scribes",
      link: "https://www.youtube.com/watch?v=JQ9oceOyuDk",
      title: "The History and Anatomy of Flourishing",
      dates: "Mar 2021",
    },
    {
      host: "Letterform Archive",
      link: "https://letterformarchive.org/type-west-online/",
      title: "Type West: Type Design",
      dates: "Jun-Aug 2021",
    },
    {
      host: "Parsons School of Design",
      link: "https://courses.newschool.edu/courses/PSAM3010",
      title: "Type Design",
      dates: "Jan-May 2021",
    },
    {
      host: "Type@Cooper",
      link: "https://github.com/spacetypeco/generative-typography-FA20",
      title: "Generative Typography",
      dates: "Oct-Dec 2020",
    },
    {
      host: "Type@Cooper",
      link: "https://github.com/spacetypeco/generative-typography-SU20",
      title: "Generative Typography",
      dates: "Jun-Jul 2020",
    },
    {
      host: "Letterform Archive",
      link: "https://letterformarchive.org/",
      title: "Intro to Lettering",
      dates: "Jun 2020",
    },
    {
      host: "Society of Scribes",
      link: "https://www.societyofscribes.org/calendar/designing-flourishes-spring2020-1",
      title: "Designing Flourishes",
      dates: "May 2020",
    },
    {
      host: "Type@Cooper",
      link: "https://coopertype.org/workshops/",
      title: "Hand Lettering",
      dates: "Feb-Apr 2020",
    },
    {
      host: "Parsons School of Design",
      link: "https://courses.newschool.edu/courses/PSAM3010",
      title: "Type Design",
      dates: "2020",
    },
    {
      host: "Letterform Archive",
      link: "https://letterformarchive.org/",
      title: "Type West Core Workshop",
      dates: "2020",
    },
    {
      host: "Society of Scribes",
      link: "https://www.societyofscribes.org/prototyping-letterforms-with-unconventional-tools",
      title: "Prototyping Letteforms with Unconventional Tools",
      dates: "2019",
    },
    {
      host: "Type@Cooper",
      link: "https://coopertype.org/workshops/",
      title: "Calligraphy: Italic and Bâtarde",
      dates: "2019",
    },
    {
      host: "Ladies Wine & Design",
      link: "https://ladieswinedesign.com/brooklyn/",
      title: "Type Design 101",
      dates: "2019",
    },
    {
      host: "SVA Residency in Typography",
      link: "",
      title: "Calligraphy for Type Design",
      dates: "2019",
    },
    {
      host: "Type@Cooper",
      link: "http://ladieswinedesign.com/",
      title: "Calligraphy: Historical Hands",
      dates: "2019",
    },
    {
      host: "Letterform Archive",
      link: "https://letterformarchive.org/",
      title: "Calligraphy as a Tool for Prototyping Letterforms",
      dates: "2019",
    },
    {
      host: "Letterform Archive",
      link: "https://letterformarchive.org/",
      title: "Designing Flourishes",
      dates: "2019",
    },
    {
      host: "ECV Paris",
      link: "https://medium.com/ecvny/2019-new-york-typographic-tour-schedule-cdf860e103e8",
      title: "Masterclass",
      dates: "2019",
    },
    {
      host: "Type@Cooper",
      link: "http://coopertype.dreamhosters.com/events/calligraphy_blackletter_fundamentals",
      title: "Calligraphy: Blackletter Fundamentals",
      dates: "2019",
    },
    {
      host: "HUGE Inc",
      link: "http://www.hugeinc.com/",
      title: "Blackletter Calligraphy",
      dates: "2018",
    },
    {
      host: "Society of Scribes",
      link: "http://societyofscribes.org/",
      title: "Basics of Blackletter",
      dates: "2017",
    },
    {
      host: "Society of Scribes",
      link: "http://societyofscribes.org/",
      title: "Flourishing Design",
      dates: "2017",
    },
    {
      host: "TypeCon",
      link: "https://www.typecon.com/",
      title: "Flourishing Design",
      dates: "2017",
    },
    {
      host: "Society of Scribes",
      link: "https://www.societyofscribes.org/",
      title: "Writing with Gradients",
      dates: "2017",
    },
  ];

  const teachingSplitIndex = Math.ceil(TEACHING_AND_WORKSHOPS.length / 2);

  const SPEAKING_ENGAGEMENTS = [
    {
      host: "Seattle Art Book Fair",
      title: "Type Design for Publications",
      dates: "May 2026",
    },
    {
      host: "Yale School of Art",
      title: "Software for People",
      dates: "Feb 2026",
    },
    {
      host: "Katherine Small Gallery",
      title: "Korean Talismans",
      dates: "Jan 2026",
    },
    { host: "Society of Printers", title: "Lecture Series", dates: "Jan 2026" },
    {
      host: "Pioneer Works",
      link: "https://pioneerworks.org/programs/software-for-artists-day-8",
      title: "Software for Artists Day",
      dates: "Nov 2023",
    },
    {
      host: "Adobe MAX",
      link: "https://www.adobe.com/max/2023/sessions/na-generative-typography-creative-technology-as-mu-vs305.html",
      title: "Generative Typography: Creative Technology as Muse",
      dates: "Oct 2023",
      videoLink:
        "https://www.adobe.com/max/2023/sessions/na-generative-typography-creative-technology-as-mu-vs305.html",
    },
    {
      host: "MIT Media Lab",
      link: "https://www.media.mit.edu/posts/lunch-lectures-computational-typography/",
      title: "Future Sketches: Computational Typography Lunch Lectures",
      dates: "Sep 2023",
      videoLink: "https://www.youtube.com/watch?v=nlKJPWGQGkc",
    },
    {
      host: "ATypI Paris",
      link: "https://atypi.org/presentation/ghost-glitch-or-muse-designing-with-fallible-machines/",
      title: "Designing with Fallible Machines",
      dates: "May 2023",
      videoLink: "https://www.youtube.com/watch?v=0r9OboZuIUg",
    },
    {
      host: "MassArt",
      link: "https://massart.edu/academics/programs/communication-design",
      title: "Communication Design Lecture Series",
      dates: "May 2023",
    },
    {
      host: "Letràstrica",
      link: "https://www.letrastica.com/en/festival-4",
      title: "Perfection Doesn't Exist",
      dates: "Oct 2022",
    },
    {
      host: "Typographics",
      link: "https://2022.typographics.com/",
      title: "Main Conference",
      dates: "Jun 2022",
      videoLink: "https://www.youtube.com/watch?v=4YcT3C6a3QA",
    },
    {
      host: "Typographics TypeLab",
      link: "https://2022.typographics.com/typelab/",
      title: "Vartype: Generative sketches for variable fonts",
      dates: "Jun 2022",
    },
    {
      host: "GRANSHAN",
      link: "https://signs-of-the-times.net/",
      title: "Sign of the Times",
      dates: "May 2022",
      videoLink: "https://www.youtube.com/watch?v=jw4avHNFJ8w",
    },
    {
      host: "Type Network",
      link: "https://typenetwork.com/articles/our-video-series-on-variable-fonts",
      title: "Designing Tomorrow Today",
      dates: "Apr 2022",
      videoLink:
        "https://typenetwork.com/articles/designing-with-variable-fonts-designing-tomorrow-today",
    },
    {
      host: "Society of Scribes",
      link: "https://www.societyofscribes.org/blog/2021-annual-general-meeting-flourishing-lynne-yun",
      title: "History and Anotomy of Flourishing",
      dates: "Mar 2021",
      videoLink: "https://www.youtube.com/watch?v=JQ9oceOyuDk",
    },
    {
      host: "ATypI",
      link: "https://atypi.org/conferences-events/past-conferences/atypi-all-over-2020/",
      title: "Type, Technology, and Beyond",
      dates: "Oct 2020",
      videoLink: "https://www.youtube.com/watch?v=ODWYhDC_GFQ",
    },
    {
      host: "Parsons School of Design",
      link: "https://event.newschool.edu/onlineparsonscdlectureseries",
      title: "Communication Design Lecture Series",
      dates: "Sep 2020",
      videoLink: "https://www.youtube.com/watch?v=NwVhOxKtwbg",
    },
    {
      host: "Parsons School of Design",
      link: "https://newschool.edu",
      title: "'History of the Latin Alphabet' Lecture Series",
      dates: "Sep 2020",
      videoLink: "https://typedesignschool.com/usage/curriculum/Section_6",
    },
    {
      host: "Typographics TypeLab",
      link: "http://typographics.com/",
      title: "Type, Technology, & Algorithms",
      dates: "Sep 2020",
    },
    {
      host: "Wayzgoose",
      link: "https://woodtype.org/pages/wayzgoose",
      title: "Material Creativity: Finding Inspiration in New Mediums",
      dates: "2019",
      videoLink: "https://www.youtube.com/watch?v=5loIss8n4bY",
    },
    {
      host: "TypeCon",
      link: "https://www.typecon.com/",
      title: "History and Anatomy of Flourishing",
      dates: "2019",
    },
    {
      host: "Typographics TypeLab",
      link: "https://typographics.com/",
      title: "Behind the History of the Type Studio",
      dates: "2019",
    },
    {
      host: "Letterform Archive",
      link: "https://letterformarchive.org/events/view/letters-a-code-system/",
      title: "Letters: A Code System",
      dates: "2019",
      videoLink: "https://www.youtube.com/watch?v=kjsR8tEj4Rg",
    },
    {
      host: "TypeCon",
      link: "https://www.typecon.com/",
      title: "Reviving a Calligraphy Hand",
      dates: "2018",
      videoLink: "https://www.youtube.com/watch?v=mKyulbXhF0E",
    },
    {
      host: "Typographics TypeLab",
      link: "https://typographics.com/",
      title: "History of Flourishing",
      dates: "2017",
    },
    {
      host: "HUGE Inc",
      link: "https://www.hugeinc.com/",
      title: "Type Journey",
      dates: "2017",
    },
    {
      host: "Frog Design",
      link: "https://frogdesign.com/",
      title: "Creative Forum",
      dates: "2017",
    },
    {
      host: "Typographics: The Magazine",
      link: "https://typographics.com",
      title: "Failures",
      dates: "2016",
    },
  ];

  const INTERVIEWS_AND_PRESS = [
    {
      host: "Kudos AM/PM",
      link: "https://www.youtube.com/watch?v=hdBxf3UkVJU",
      dates: "2026",
    },
    {
      host: "Type Directors Club",
      title: "Weekly Typographic",
      link: "https://tdc.org/weekly-type/play/",
      dates: "2025",
    },
    {
      host: "You Are Not Alone",
      title: "Stories Behind the Wall: Mental Health & the Arts",
      link: "https://www.youtube.com/watch?v=QLuKDKCSY3k",
      dates: "2024",
    },
    {
      host: "Pioneer Works x SFPC",
      title: "Software for Artists: In Poetic Coalition",
      link: "https://store.pioneerworks.org/products/s4ad-poetic-coalition",
      dates: "2023",
    },
    {
      host: "NEW INC x Rhizome",
      link: "https://www.newinc.org/members",
      title: "Year 10 - Art & Code Member",
      dates: "2023",
    },

    {
      host: "OHno Radio",
      link: "https://ohnotype.co/blog/ohno-radio-episode-25-type-electives",
      dates: "2023",
    },
    {
      host: "I Love Typography (ILT)",
      link: "https://ilovetypography.com/2021/03/08/women-of-letters/",
      dates: "2021",
    },
    {
      host: "Night Snack Club",
      link: "https://www.nightsnackclub.com/blog/lynneyun",
      dates: "2020",
    },
    {
      host: "League of Movable Type Podcast",
      link: "https://www.theleagueofmoveabletype.com/podcast/s2e13---interview-with-type-designer--educator-lynne-yun",
      dates: "2020",
    },
    {
      host: "Debugger",
      link: "https://debugger.medium.com/crowd-funding-an-online-course-with-low-budget-and-a-lot-of-elbow-grease-in-2020-809f08f509df",
      title: "Crowdfunding an Online Course During Quarantine",
      dates: "2020",
    },
    {
      host: "NaN",
      link: "https://nan.xyz/txt/glyphzian-space/",
      title: "Glyphzian Space",
      dates: "2020",
    },
    {
      host: "Letter Arts Review Vol. 33:4",
      link: "",
      dates: "2020",
    },
    {
      host: "ECV NY Masterclass",
      link: "https://vimeo.com/326059621",
      dates: "2019",
    },
    {
      host: "Communication Arts",
      link: "https://www.commarts.com/favorites/five-typographers-share-their-treasured-finds-3",
      dates: "2019",
    },
    {
      host: "Alphabet",
      link: "",
      dates: "2017",
    },
    {
      host: "Print Magazine",
      link: "https://www.dropbox.com/s/eexcqfw2pvlmg58/PRINT%20Mag%20Summer2017%20Excerpt.pdf?dl=0",
      dates: "2017",
    },
    {
      host: "Typodarium",
      link: "https://www.dropbox.com/s/4jicdvwlc09zk9p/Letter_Arts_Review_2017.pdf?dl=0",
      dates: "2017",
    },
    {
      host: "Letter Arts Review Vol. 31",
      link: "",
      dates: "2017",
    },
    {
      host: "TypeThursday",
      link: "https://medium.com/type-thursday/go-backwards-to-go-forward-an-interview-with-graphic-designer-lynne-yun-cd2361202400#.9h219pi8h",
      dates: "2016",
    },
    {
      host: "Art Directors Club",
      link: "http://adcglobal.org/lynne-yun-chance-destiny/",
      dates: "2016",
    },
    {
      host: "Working Not Working",
      link: "http://freerange.workingnotworking.com/blog/2015/5/11/9jzv50x1ilwh4r43vi3gh0dlrcfmlm",
      dates: "2015",
    },
    {
      host: "Campaign US",
      link: "",
      dates: "2015",
    },
    {
      host: "KERA (NPR & PBS)",
      link: "http://keranews.org/post/designers-placeholder-lorem-ipsum-sense-poetry",
      dates: "2015",
    },
    {
      host: "CMYK Magazine #7",
      link: "",
      dates: "2015",
    },
    {
      host: "CA Korea Magazine #183",
      link: "",
      dates: "2015",
    },
  ];

  const EXHIBITIONS = [
    {
      host: "Riso-Rama",
      link: "https://www.riso-rama.com/dreams",
      title: "Dreaming of: Riso-Rama Reading Room @ Dallas Art Book Fair",
      dates: "2026",
    },
    {
      host: "Bronx Museum",
      link: "https://bronxmuseum.org/exhibition/working-knowledge/",
      title: "Working Knowledge: Shared Imaginings, New Futures",
      dates: "2025",
    },
    {
      host: "Museum of the Moving Image",
      link: "https://movingimage.org/event/thingyou/",
      title: "THING x YOU (Development Support)",
      dates: "2025",
    },
    {
      host: "Plexus Projects",
      link: "https://www.plexusprojects.org/gui-gooey-2024",
      title: "GUI/GOOEY",
      dates: "2024",
    },
    {
      host: "Neighbor",
      title: "Meek Defiance",
      dates: "2024",
    },
    {
      host: "Schick Art Gallery",
      link: "https://www.skidmore.edu/schick/2022-2023/true-type-exhibition.php",
      title: "True to Type",
      dates: "2022",
    },
    {
      host: "Letràstrica",
      link: "https://www.letrastica.com/en/festival-4",
      title: "Collective Exhibition",
      dates: "2022",
    },
    {
      host: "School for Poetic Computation",
      link: "https://sfpc.io/sevenyears/",
      title: "Poetic Computation: Seven Years of SFPC",
      dates: "2020",
    },
    {
      host: "Korean Cultural Center New York",
      link: "https://www.koreanculture.org/gallery-korea/2018/8/16/found-in-translation",
      title: "Found in Translation",
      dates: "2018",
    },
    {
      host: "Type Directors Club",
      link: "",
      title: "Ascenders",
      dates: "2018",
    },
    {
      host: "The Grolier Club",
      link: "",
      title: "The Calligraphy Revival",
      dates: "2017",
    },
    {
      host: "Type Directors Club",
      link: "",
      title: "TDC 62",
      dates: "2016",
    },
    {
      host: "Type Directors Club",
      link: "",
      title: "TDC 60",
      dates: "2014",
    },
  ];

  const Table = (items) => (
    <table className="table-fixed col-span-6 min-w-full">
      <tbody>
        {items.map((info) => (
          <tr>
            <td className="text-start">
              {info.link ? (
                <a
                  className="color-fedblue color-fluopink-hover"
                  href={info.link}
                >
                  {info.host}
                </a>
              ) : (
                info.host || info.title
              )}
            </td>
            <td className={info.title ? "" : "opacity-25"}>
              {info.title}
              {info.videoLink ? (
                <>
                  {" "}
                  (
                  <Link href={info.videoLink} className="color-fedblue">
                    video
                  </Link>
                  )
                </>
              ) : (
                ""
              )}
            </td>
            <td
              className="text-start"
              style={{ width: `${info.dates ? "7rem" : "12rem"}` }}
            >
              {info.dates || info.location}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <>
      <Head>
        <title>Space Type - About</title>
        <meta property="og:title" content="Space Type - About" />
      </Head>
      <style jsx global>{`
        // h1,
        // h2,
        // h3,
        // h4,
        // h5,
        // h6 {
        //   font-family: "ST Felicette Regular", monospace;
        //   transition: color var(--theme-transition-time);
        // }

        // p,
        // a,
        // span,
        // ul,
        // input {
        //   font-family: "ST Monochromic", monospace;
        //   font-weight: 60;
        //   font-size: 1rem;
        // }

        td {
          padding-block: 4px;
          border-bottom: 1px solid #ac936ebb;
        }

        td:last-child {
          text-align: right;
        }

        td:not(:last-child) {
          padding-right: 5px;
        }

        td,
        td a {
          font-family: "ST Monochromic", monospace;
          font-weight: 60;
          font-size: 0.9rem;
        }

        .grid {
          max-width: none;
          margin: 0;
        }

        .about-intro--image {
          grid-column: 8 / span 5;
          grid-row: 1 / 1;
        }

        .about-intro--text {
          grid-column: 1 / span 12;
          grid-row: 1 / 1;
          grid-template-rows: auto auto;
          align-content: start;
        }

        .about-intro--text-subtext {
          grid-column: 1 / span 6;
        }
        @media (min-width: 768px) {
          .builders-img {
            height: calc(min(32rem, 100vw * 0.5));
          }
        }

        @media (max-width: 768px) {
          .group .builders-img {
            height: calc(100vw * 0.6);
          }
          .about-intro--text-subtext {
            grid-column: 1 / span 12;
          }
          .about-intro--image {
            grid-column: 1 / span 12;
          }
        }

        @media (min-width: 1900px) {
          td,
          td a {
            font-size: 0.85rem;
          }
        }

        @media (max-width: 1024px) {
          .content-wide-mobile {
            margin-inline: 1em;
          }
          .about-intro--text-subtext {
            grid-column: 1 / span 10;
          }
          .about-intro--image {
            grid-column: 4 / span 8;
          }
          .about-intro--text {
            grid-row: 2 / span 1;
          }
        }

        @media (min-width: 1600px) {
          .container-wide:not(.lg-content-uber-uber-wide) {
            margin-inline: auto;
            max-width: 1500px;
          }
          .lg-content-uber-uber-wide {
            max-width: 120rem;
          }
        }
      `}</style>
      <PageFadeWrapper>
        <div>
          <div
            id="container"
            className="full-w full-h"
            style={
              {
                // background: `linear-gradient(var(--color-gold) -25%, var(--color-gold) 50%, var(--color-gold) 150%)`,
              }
            }
          >
            <div id="about" className="nav-spacer--padded mb-24">
              <section className="fade-in content-top md:flex flex-row justify-center lg:px-12">
                <div className="3xl:pt-6 lg-content-uber">
                  <div className="pt-4 md:pt-12 md:grid grid-cols-12 auto-rows-auto">
                    <div className="relative md:float-right tile about-intro--image">
                      <ResponsiveImage
                        src={imgConcourseBinding12}
                        alt="Image"
                        containerClassNames="hidden lg:block"
                        sizes="(max-width: 768px) 50vw, (max-width: 1900px) 30vw, 600px"
                        styles={{ zIndex: 110 }}
                      ></ResponsiveImage>
                      <ResponsiveImage
                        src={imgConcourseBindingHorizLg}
                        ignoreRounded={true}
                        containerClassNames="lg:hidden rounded-none md:rounded"
                        className="rounded-none md:rounded-xl"
                        sizes="(max-width: 768px) 100vw, (max-width: 1900px) 100vw, 1500px"
                        styles={{ zIndex: 110 }}
                        alt="About Cover"
                      ></ResponsiveImage>
                    </div>
                    <div
                      className="z-10 grid-cols-12 about-intro--text content-wide-mobile"
                      style={{ display: "grid" }}
                    >
                      <h1 className="felicette-Bold color-gold text-4xl md:text-6xl col-span-10 md:col-span-10 lg:col-span-7 mb-0 mt-16 3xl:mt-20 ml-0 md:ml-12 lg:ml-0 md:mr-8">
                        Space Type is a{" "}
                        <span className="felicette-Bold color-fluoorange">
                          type foundry
                        </span>
                        ,{" "}
                        <span className="felicette-Bold color-blue">
                          design studio
                        </span>
                        , and{" "}
                        <span className="felicette-Bold color-fluopink">
                          risograph press
                        </span>{" "}
                        based in Brooklyn, NY.
                      </h1>
                      {/* <h1 className="felicette-bold text-3xl md:text-5xl 3xl:text-6xl col-span-11 md:col-span-10 lg:col-span-8 mb-0 mt-8 md:mt-16 3xl:mt-20 ml-0 md:ml-12 lg:ml-0"> */}
                      {/* <br className="hidden 3xl:block 3xl:hidden" /> of type and */}
                      <div className="mt-12 about-intro--text-subtext text-lg md:pr-8 ml-0 md:ml-12 lg:ml-0">
                        <p className="monochromic-semilight">
                          We design original typefaces, illustrate across
                          mediums, and produce risograph prints, art books,
                          comics, and greeting cards.
                        </p>
                        <p className="monochromic-semilight">
                          Our work aims to improve access to typographic
                          education, surface rich ethnic stories, and highlight
                          the vibrancy of a good idea — usually inspired by
                          fantasy fauna, flora, and a playful touch of
                          lettering.
                        </p>
                      </div>
                    </div>
                    {/* <div className="pt-4 md:pt-12 flex flex-col-reverse xl:flex-row gap-8"> */}
                    {/* <div className="z-10 about-intro--text self-start flex-auto md:flex-1 xl:flex-auto container-wide"> */}
                    {/* BREAK  */}
                    {/* <div className="mt-4 lg:mt-12 max-w-prose text-lg pr-8 ml-0 color-black"> */}
                    {/* <div>
                          <img
                            src={imgWorkingHard.src}
                            // sizes="200px"
                            // containerClassNames="h-64 mt-24 mb-6 lg:my-12"
                            // style={{
                            //   height: "16rem !important",
                            // }}
                            className="h-64 mt-24 mb-6 lg:my-12 z-10"
                          />
                        </div> */}
                    {/* </div> */}
                    {/* </div> */}
                    {/* <div className="about-intro--image xl:hidden">
                  <ResponsiveImage
                    src={imgConcourseBindingHorizLg}
                    sizes="(max-width: 768px) 100vw, (max-width: 1900px) 100vw, 1500px"
                    styles={{ zIndex: 110 }}
                    alt="About Cover"
                    roundedBorder={0}
                  ></ResponsiveImage>
                </div>
                <div className="rounded about-intro--image hidden xl:block">
                  <ResponsiveImage
                    src={imgConcourseBinding12}
                    sizes="(max-width: 768px) 50vw, (max-width: 1900px) 20vw, 500px"
                    styles={{ zIndex: 110 }}
                    alt="About Cover"
                  ></ResponsiveImage>
                </div> */}
                  </div>
                </div>
              </section>

              <section className="my-24 lg:my-48 w-full flex justify-start max-w-[90vw] xl:max-w-[100rem] content-wide-mobile">
                <div style={{ zIndex: 110 }}>
                  <div className="flex flex-col md:flex-row items-start gap-12 md:gap-2">
                    <div className="md:max-w-full">
                      <img src={imgAppleActivation1Adjusted.src} alt="" />
                      <div className="flex flex-col gap-1 mt-2 pr-1 items-end w-full">
                        <span className="text-xs md:text-sm">
                          Calligraphy Activation @ Apple 5th Ave
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-row gap-2">
                      <div>
                        <img src={imgDocusignRenaissanceAdjusted.src} alt="" />
                        <div className="flex flex-col gap-1 mt-2 pr-1 items-end w-full">
                          <span className="text-xs md:text-sm">
                            ST Nebulith for Docusign's 20th anniversary
                          </span>
                        </div>
                      </div>
                      <div>
                        <img src={imgNike170717.src} alt="" />
                        <div className="flex flex-col gap-1 mt-2 pr-1 items-end w-full">
                          <span className="text-xs md:text-sm">
                            HWT Etta in use for Nike
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section className="my-24 lg:my-48 content-wide-mobile">
                <h1 className="felicette-Bold text-3xl md:text-4xl lg:hidden color-gold mb-8">
                  Studio Partners
                </h1>
                <div className="flex flex-col md:flex-row gap-x-8 2xl:gap-x-16 md:mb-24">
                  <div
                    className="flex-1 md:max-w-2xl xl:max-w-4xl"
                    style={{ zIndex: 110 }}
                  >
                    <img src={imgFriendship3.src} alt="" />
                  </div>
                  <div className="flex-1 max-w-prose self-start mt-4 mb-8 md:mt-16 md:mb-0 mr-4 lg:mr-12">
                    <h1 className="text-5xl hidden lg:block color-gold mb-8">
                      Studio Partners
                    </h1>
                    <p className="text-lg monochromic-semilight">
                      Kevin Yeh (he/him) is a Burmese-American designer,
                      developer, and educator. His work is primarily focused on
                      computational art, pattern-based visuals, photography, and
                      silly little doodles to hide the fact that he can't draw.
                      He is the primary operator of the risograph press and
                      practice, including public operations, in-person events,
                      wholesale stocking to independent book stores, and
                      managing the{" "}
                      <FoundryLink
                        href="https://artbookfairs.com"
                        className="color-fluopink"
                      >
                        artbookfairs.com
                      </FoundryLink>{" "}
                      resource.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col-reverse md:flex-row justify-end gap-x-8 2xl:gap-x-16 ml-4 lg:ml-12">
                  <div className="flex-1 max-w-prose self-end mt-4 mb-16 text-end">
                    <p className="text-lg monochromic-semilight">
                      Lynne Yun (she/her) is a Korean-American typeface
                      designer, technologist, and educator. From crafting woven
                      calligraphic pieces to designing type for screens and
                      publications, Lynne's work spans an evolving set of
                      multimedia to bring a personal touch to everyday
                      interactions. She is a co-founder of Type Electives, an
                      alumna of the Type@Cooper Extended program, School for
                      Poetic Computation, and ITP at NYU, and previously taught
                      for institutions such as Type@Cooper, Parsons School of
                      Design, and The Letterform Archive.
                    </p>
                  </div>
                  <div
                    className="flex-1 md:max-w-2xl xl:max-w-4xl"
                    style={{ zIndex: 110 }}
                  >
                    <img src={imgHsfLandscape.src} style={{ zIndex: 110 }} />
                  </div>
                </div>
              </section>

              <section className="content-wide lg-content-uber-uber-wide mx-auto md:grid grid-cols-12 my-24 lg:my-48 gap-24">
                <div
                  className="col-span-6 flex flex-col gap-6 md:mt-96 mb-6"
                  style={{ zIndex: 110 }}
                >
                  <div>
                    <ResponsiveImage
                      src={imgSpacetypeKittyTigersPromo}
                      alt="Kitty and Tiger Zines"
                      roundedBorder={0}
                    ></ResponsiveImage>
                    <div className="float-right mt-2 text-xs md:text-sm pr-2 md:pr-0">
                      <FoundryLink
                        href="/shop/kittypop"
                        className="color-fluopink"
                      >
                        KittyPop (2nd Ed. 2024)
                      </FoundryLink>{" "}
                      and{" "}
                      <FoundryLink
                        href="/shop/tiger-stuff-2"
                        className="color-fluopink"
                      >
                        Tiger Stuff (2nd Ed. 2025)
                      </FoundryLink>
                    </div>
                  </div>
                  <div>
                    <ResponsiveImage
                      src={imgSpacetypePrintsPromo}
                      alt="Small snake prints"
                      roundedBorder={0}
                    ></ResponsiveImage>
                    <div className="float-right mt-2 text-xs md:text-sm pr-2 md:pr-0">
                      <FoundryLink
                        href="/shop/snake-time"
                        className="color-fluopink"
                      >
                        Snake Time (2025)
                      </FoundryLink>{" "}
                      and{" "}
                      <FoundryLink
                        href="/shop/my-myself-and-i"
                        className="color-fluopink"
                      >
                        Me, Myself, and I (2023)
                      </FoundryLink>
                    </div>
                  </div>
                  <div>
                    <ResponsiveImage
                      src={imgPathways}
                      alt="Pathways generative art zine"
                      roundedBorder={0}
                    ></ResponsiveImage>
                    <div className="float-right mt-2 text-xs md:text-sm pr-2 md:pr-0">
                      <FoundryLink
                        href="/shop/pathways-zine"
                        className="color-fluopink"
                      >
                        Pathways zine
                      </FoundryLink>{" "}
                      and{" "}
                      <FoundryLink
                        href="/shop/pathways-poster"
                        className="color-fluopink"
                      >
                        poster (2025)
                      </FoundryLink>
                    </div>
                  </div>
                </div>
                <div
                  className="col-span-6 flex flex-col gap-6"
                  style={{ zIndex: 110 }}
                >
                  <div>
                    <ResponsiveImage
                      src={imgProductionYana}
                      alt="You are not alone mural"
                      roundedBorder={0}
                    ></ResponsiveImage>
                    <div className="flex flex-col mt-2 pl-2 md:pl-0 items-start w-full">
                      <span className="text-xs md:text-sm">
                        You Are Not Alone
                      </span>
                      <span className="text-xs md:text-sm text-right">
                        South Street Seaport, New York
                      </span>
                    </div>
                  </div>
                  <div>
                    <ResponsiveImage
                      src={imgProductionWtc}
                      alt="World Trade Center mural"
                      roundedBorder={0}
                    ></ResponsiveImage>
                    <div className="flex flex-col mt-2 pl-2 md:pl-0 items-start w-full">
                      <span className="text-xs md:text-sm">
                        Welcome to the WTC
                      </span>
                      <span className="text-xs md:text-sm text-right">
                        World Trade Center, New York
                      </span>
                    </div>
                  </div>
                  <div>
                    <ResponsiveImage
                      src={imgProductionBroadwayMural}
                      alt="Broadway mural"
                      roundedBorder={0}
                    ></ResponsiveImage>
                    <div className="flex flex-col mt-2 pl-2 md:pl-0 items-start w-full">
                      <span className="text-xs md:text-sm">
                        120 Broadway Mural
                      </span>
                      <span className="text-xs md:text-sm text-right">
                        New York, New York
                      </span>
                    </div>
                  </div>
                </div>
              </section>

              <section className="my-24 lg:my-48">
                <div style={{ maxWidth: "100rem" }}>
                  <div className="flex flex-col md:flex-row items-start gap-12 md:gap-2">
                    <div className="md:max-w-full" style={{ zIndex: 110 }}>
                      <img src={imgAceVisitor2025.src} alt="" />
                      <div className="flex flex-col gap-1 mt-2 pr-2 md:pr-0 items-end w-full">
                        <span className="text-xs md:text-sm">
                          ACE* Popup, May 2025
                        </span>
                        <span className="text-xs md:text-sm">
                          New York, New York
                        </span>
                      </div>
                    </div>
                    <div
                      className="flex flex-row gap-2"
                      style={{ zIndex: 110 }}
                    >
                      <div>
                        <img src={imgAnimenyc2025.src} alt="" />
                        <div className="flex flex-col gap-1 mt-2 items-end w-full">
                          <span className="text-xs md:text-sm">
                            Anime NYC, August 2025
                          </span>
                          <span className="text-xs md:text-sm text-right">
                            New York, New York
                          </span>
                        </div>
                      </div>
                      <div style={{ zIndex: 110 }}>
                        <img src={imgSabf2025.src} alt="" />
                        <div className="flex flex-col gap-1 mt-2 pr-2 items-end w-full">
                          <span className="text-xs md:text-sm">
                            Seattle Art Book Fair, May 2025
                          </span>
                          <span className="text-xs md:text-sm text-right">
                            Seattle, Washington
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section className="my-24 lg:my-48 w-full flex justify-end">
                <div style={{ maxWidth: "100rem", zIndex: 110 }}>
                  <div className="flex flex-col md:flex-row items-end gap-12 md:gap-2">
                    <div className="md:max-w-full">
                      <img src={imgLaabf.src} alt="" />
                      <div className="flex flex-col gap-1 mt-2 pl-2 items-start w-full">
                        <span className="text-xs md:text-sm">
                          LA Art Book Fair, 2025
                        </span>
                        <span className="text-xs md:text-sm">
                          Los Angeles, California
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-row gap-2">
                      <div>
                        <img src={imgNucleus.src} alt="" />
                        <div className="flex flex-col gap-1 mt-2 pl-2 md:pl-0 items-start w-full">
                          <span className="text-xs md:text-sm">
                            Riso Art & Zine (RAZ) Fest, 2025
                          </span>
                          <span className="text-xs md:text-sm text-right">
                            Gallery Nucleus, Alhambra, California
                          </span>
                        </div>
                      </div>
                      <div>
                        <img src={imgUe17.src} alt="" />
                        <div className="flex flex-col gap-1 mt-2 items-start w-full">
                          <span className="text-xs md:text-sm">
                            Unlimited Edition (Seoul Art Book Fair), 2025
                          </span>
                          <span className="text-xs md:text-sm text-right">
                            Seoul, South Korea
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <div className="lg:flex justify-center">
                <section className="container-wide lg-content-uber-uber-wide">
                  <div className="md:grid grid-cols-12 gap-6 mt-12">
                    <div className="col-span-6 mb-12 md:mb-0">
                      <h1 className="text-3xl mb-4">Fairs and Markets</h1>
                      {Table(PUBLICATION_FAIRS)}
                    </div>{" "}
                    <div className="col-span-6">
                      <h1 className="text-3xl mb-4">Retailers</h1>
                      {Table(RETAILERS)}
                    </div>
                  </div>

                  <section className="my-24 lg:my-48">
                    <div style={{ maxWidth: "100rem" }}>
                      <div className="flex flex-col md:flex-row items-start gap-12 md:gap-2">
                        <div className="md:max-w-full" style={{ zIndex: 110 }}>
                          <img src={imgCommunity1.src} alt="" />
                          <div className="flex flex-col gap-1 mt-2 pr-1 items-end w-full">
                            <span className="text-xs md:text-sm">
                              Generative Typography Workshop
                            </span>
                            <span className="text-xs md:text-sm">
                              Letràstica, Guadalajara, Mexico
                            </span>
                          </div>
                        </div>
                        <div className="flex flex-row gap-2">
                          <div style={{ zIndex: 110 }}>
                            <img src={imgCommunity2.src} alt="" />
                            <div className="flex flex-col gap-1 mt-2 pr-1 items-end w-full">
                              <span className="text-xs md:text-sm">
                                Flourishing Workshop
                              </span>
                              <span className="text-xs md:text-sm text-right">
                                Letterform Archive
                                <br className="md:hidden" />
                                <span className="hidden md:inline-block">
                                  ,
                                </span>{" "}
                                San Francisco
                              </span>
                            </div>
                          </div>
                          <div style={{ zIndex: 110 }}>
                            <img src={imgCommunity3.src} alt="" />
                            <div className="flex flex-col gap-1 mt-2 pr-1 items-end w-full">
                              <span className="text-xs md:text-sm">
                                Pixel Type Workshop
                              </span>
                              <span className="text-xs md:text-sm text-right">
                                Principles G.I. Coffee Shop
                                <br className="md:hidden" />
                                <span className="hidden md:inline-block">
                                  ,
                                </span>{" "}
                                Brooklyn
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <h1 className="text-3xl mb-4 mt-12">
                    Teaching and Workshops
                  </h1>
                  <div className="md:grid grid-cols-12 gap-6 hidden md:block">
                    {[0, 1].map((tableNum) =>
                      Table(
                        TEACHING_AND_WORKSHOPS.slice(
                          tableNum * teachingSplitIndex,
                          (tableNum + 1) * teachingSplitIndex,
                        ),
                      ),
                    )}
                  </div>
                  <div className="md:hidden text-start">
                    {Table(TEACHING_AND_WORKSHOPS)}
                  </div>
                  <section className="my-24 lg:my-48 flex justify-end">
                    <div style={{ maxWidth: "100rem" }}>
                      <div className="flex flex-col md:flex-row items-start justify-end gap-12 md:gap-2">
                        <div className="md:max-w-full" style={{ zIndex: 110 }}>
                          <img src={imgSpeakingLg.src} alt="" />
                        </div>
                        <div className="flex flex-row gap-2">
                          <div style={{ zIndex: 110 }}>
                            <img src={imgAppleActivationWorking.src} alt="" />
                          </div>
                          <div style={{ zIndex: 110 }}>
                            <img src={imgPixelTypeOutput.src} alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div className="md:grid grid-cols-12 gap-6 mt-12">
                    <div className="col-span-6 mb-12 md:mb-0">
                      <h1 className="text-3xl mb-4">
                        Select Speaking Engagements
                      </h1>
                      {Table(SPEAKING_ENGAGEMENTS)}
                    </div>{" "}
                    <div className="col-span-6">
                      <h1 className="text-3xl mb-4">Interviews and Press</h1>
                      {Table(INTERVIEWS_AND_PRESS)}
                    </div>
                  </div>
                  <section className="my-24 lg:my-48 max-w-7xl mx-auto">
                    <div className="flex flex-col md:flex-row gap-12 md:gap-2">
                      <div className="flex flex-row gap-2">
                        <div style={{ zIndex: 110 }}>
                          <img src={imgWorkingKnowledgeLandscape.src} alt="" />
                          <div className="flex flex-col mt-2 pr-1 items-end w-full">
                            <Link
                              href="https://bronxmuseum.org/exhibition/working-knowledge/"
                              className="text-xs md:text-sm color-fluopink"
                            >
                              Working Knowledge
                            </Link>
                            <span className="text-xs md:text-sm text-right">
                              Bronx Museum, New York
                            </span>
                          </div>
                        </div>
                        <div style={{ zIndex: 110 }}>
                          <img src={imgConcourseSituVertLg.src} alt="" />
                          <div className="flex flex-col mt-2 pr-1 items-end w-full">
                            <span className="text-xs md:text-sm">
                              Concourse (2025)
                            </span>
                            <span className="text-xs md:text-sm text-right">
                              Displayed as part of <i>Working Knowledge</i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <div className="flex flex-col md:grid grid-cols-12 gap-12">
                    <img
                      src={imgExhibition.src}
                      className="col-span-5"
                      style={{ zIndex: 110 }}
                    />
                    <div className="max-w-2xl col-span-7 self-end">
                      <h1 className="text-3xl mb-4">Select Exhibitions</h1>
                      {Table(EXHIBITIONS)}
                    </div>
                  </div>
                </section>
              </div>

              <section className="content-wide lg-content-uber-uber-wide my-24 lg:my-48 mx-auto px-4">
                <ResponsiveImage
                  src={imgPoetryCoversCompiledTrimmed}
                  alt="Poetry Magazine Covers"
                  roundedBorder={0}
                  styles={{ zIndex: 110 }}
                ></ResponsiveImage>
                <div className="flex flex-col gap-1 mt-2 pr-1 items-end w-full">
                  <span className="text-xs md:text-sm">
                    Poetry Magazine Illustrated Covers
                  </span>
                  <span className="text-xs md:text-sm">April-Sept 2024</span>
                </div>
              </section>

              <section className="flex flex-col items-center my-24 lg:my-48">
                <img
                  src={imgEmailBlack.src}
                  className="object-contain h-48 mb-6"
                />
                <h1 className="text-2xl">Have an idea? Send us a note.</h1>

                <a href="mailto:hello@spacetypeco.com">
                  <h2 className="text-xl">hello@spacetypeco.com</h2>
                </a>
              </section>
            </div>
          </div>
        </div>
      </PageFadeWrapper>
    </>
  );
}

About.displayName = "About";
export default About;
